let observer: IntersectionObserver | null = null
let enabled = false

const SELECTOR = '[data-reveal], [data-split]'

/** Start revealing elements as they scroll in. Called once the preloader has lifted. */
export function startReveals(): void {
  enabled = true
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll(SELECTOR).forEach((el) => el.classList.add('is-in'))
    return
  }
  observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue
        entry.target.classList.add('is-in')
        observer?.unobserve(entry.target)
      }
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.08 },
  )
  observeReveals(document)
}

/** Register reveal targets inside freshly rendered markup. */
export function observeReveals(root: ParentNode): void {
  if (!enabled) return
  root.querySelectorAll(SELECTOR).forEach((el) => {
    if (el.classList.contains('is-in')) return
    if (observer) observer.observe(el)
    else el.classList.add('is-in')
  })
}

export function isInViewport(el: Element, margin = 0): boolean {
  const r = el.getBoundingClientRect()
  return r.bottom > -margin && r.top < window.innerHeight + margin && r.width + r.height > 0
}

/** Restart the reveal transition, e.g. after the language changed. */
export function replayReveal(el: HTMLElement): void {
  if (!el.classList.contains('is-in')) return
  el.classList.remove('is-in')
  void el.offsetWidth
  el.classList.add('is-in')
}
